<template>
    <div>
      <div class="card">
        <div class="card-header">
            <div class="col-md-12">
              <ol class="breadcrumb breadcrumb-card-header pull-left">
                  <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Finance</a>
                  </li>
                  <li class="breadcrumb-item active">
                      <span v-if="cost.id === null">New</span>
                      <span v-else>
                        {{ cost.cost_no }}
                      </span>
                  </li>
              </ol>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label for="cash_date" class="col-sm-3 col-form-label text-left">Date</label>
                        <div class="col-sm-9">
                            <datetime v-model="cost.cash_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="branch_no" class="col-sm-3 col-form-label text-left">Branch</label>
                        <div class="col-sm-9">
                            <select v-model="cost.branch_no" class="form-control">
                              <option v-for="b in branchList" :key="b.id" :value="b.branch_no">{{ b.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="type_id" class="col-sm-3 col-form-label text-left">Type</label>
                        <div class="col-sm-9">
                            <select v-model="cost.type_id" class="form-control">
                              <option v-for="t in costTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="ref_no" class="col-sm-3 col-form-label text-left">Ref</label>
                        <div class="col-sm-9">
                            <input type="text" v-model="cost.ref_no" class="form-control"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="description" class="col-sm-3 col-form-label text-left">Description</label>
                        <div class="col-sm-9">
                            <input type="text" v-model="cost.description" class="form-control"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="notes" class="col-sm-3 col-form-label text-left">Notes</label>
                        <div class="col-sm-9">
                            <textarea v-model="cost.notes" class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label for="category_id" class="col-sm-3 col-form-label text-left">Category</label>
                    <div class="col-sm-9">
                        <select v-model="cost.category_id" class="form-control">
                          <option v-for="c in costCategoryList" :key="c.id" :value="c.id">{{ c.name }}</option>
                        </select>
                    </div>
                  </div>
                  <div class="form-group row">
                      <label for="bank_id" class="col-sm-3 col-form-label text-left">Bank</label>
                      <div class="col-sm-9">
                          <select v-model="cost.bank_id" class="form-control">
                            <option v-for="k in bankList" :key="k.id" :value="k.id">{{ k.name }}</option>
                          </select>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="method" class="col-sm-3 col-form-label text-left">Method</label>
                      <div class="col-sm-9">
                          <select class="form-control" v-model="cost.method">
                              <option value="in">In</option>
                              <option value="out">Out</option>
                          </select>
                      </div>
                  </div>
                  <div class="form-group row">
                    <label for="amount" class="col-sm-3 col-form-label text-left">Amount</label>
                    <div class="col-sm-9">
                      <input type="text" v-model="cost.amount" v-money="money" class="form-control"/>
                    </div>
                  </div>
                  <div class="form-group row">
                      <label for="method" class="col-sm-3 col-form-label text-left">Group</label>
                      <div class="col-sm-9">
                          <select class="form-control" v-model="cost.group_id">
                              <option value="owner">Owner</option>
                              <option value="member">Member</option>
                          </select>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
          <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
          <button type="button" @click="updateCost" class="btn btn-sm btn-primary pull-right" v-show="cost.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
          <button type="button" @click="createCost" class="btn btn-sm btn-primary pull-right" v-show="cost.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
        </div>
      </div>
      <!-- <pre>{{ cost }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { costUrl, getHeader } from '../../config'

export default {
  name: 'CostForm',
  props: ['cost'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      costTypeList: state => state.costs.costTypeList,
      costCategoryList: state => state.costs.costCategoryList,
      branchList: state => state.branches.branchList,
      bankList: state => state.banks.bankList
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateCost () {
      axios.put(costUrl + '/' + this.cost.id, this.cost, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Successfully',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '',
            'error'
          )
        })
    },
    createCost () {
      axios.post(costUrl, this.cost, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal(
            'Error!!',
            response.data,
            'error'
          )
        })
    }
  }
}
</script>
